import React from "react";
import { SectionTitle } from "@/components/Bits";
import { RequestForm } from "@/components/RequestForm";
import { WhatsAppButton } from "@/components/WhatsApp";
import { useLang } from "@/context/LanguageContext";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

export default function Contact() {
  const { t } = useLang();
  const rows = [
    [Phone, t("contact.phone"), "+228 73 37 95 46"],
    [MessageCircle, t("contact.whatsapp"), "+228 73 37 95 46"],
    [Mail, t("contact.email"), "contact@immomaxe.com"],
    [MapPin, t("contact.address"), "Lomé, Adidogomé Yokoè, Togo"],
  ];
  return (
    <div className="bg-ivory min-h-screen">
      <section className="bg-navy py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <SectionTitle light eyebrow={t("contact.eyebrow")} title={t("contact.title")} subtitle={t("contact.subtitle")} />
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-12 grid lg:grid-cols-2 gap-12">
        <div>
          <div className="space-y-5">
            {rows.map(([Icon, l, v]) => (
              <div key={l} className="flex items-center gap-4 rounded-xl bg-white border border-black/5 p-5">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-navy/5 text-gold"><Icon className="h-6 w-6" /></span>
                <div><div className="text-xs uppercase tracking-widest text-slate-400">{l}</div><div className="font-semibold text-navy">{v}</div></div>
              </div>
            ))}
          </div>
          <div className="mt-6"><WhatsAppButton label={t("contact.whatsappBtn")} className="w-full" /></div>
          <div className="mt-6 aspect-[16/9] rounded-xl overflow-hidden border">
            <iframe title="carte" width="100%" height="100%" style={{ border: 0 }} loading="lazy" src="https://maps.google.com/maps?q=Adidogom%C3%A9%20Yoko%C3%A9,%20Lom%C3%A9,%20Togo&output=embed" />
          </div>
        </div>
        <div>
          <RequestForm type="contact" title={t("contact.formTitle")} testid="contact-form" submitLabel={t("contact.submit")}
            fields={[{ name: "subject", label: t("contact.subject"), placeholder: t("contact.subjectPlaceholder") }]} />
        </div>
      </div>
    </div>
  );
}
